<template>
  <v-container fluid class="pt-0">
    <v-row dense>
      <v-col cols="12" md="6" offset-lg="2" lg="4">
        <master-benefits></master-benefits>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <master-multi-packs></master-multi-packs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import MasterBenefits from '@/components/Master/MasterBenefits.vue'
import MasterMultiPacks from '@/components/Master/MasterMultiPacks.vue'
</script>
<style scoped>
</style>
